<template>
  <div id="Deposit" class="container bnp-dp" dir="rtl">
    <loading v-if="Lodaingrenre"></loading>

    <panel
      :Title="GetPageTitle()"
      :Des="GetPageSubtitle()"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right"
    ></panel>

    <net-pa-card :Classes="'success'">
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-wallet"></i> {{ GetPageTitle() }}
        </h6>
      </template>

      <template slot="content">
        <!-- انتخاب حساب / تسهیلات -->
        <div v-if="IsShowComboHesab" class="bnp-dp-select-row">
          <label for="cmbTaahodat" class="bnp-dp-label">
            {{ GetSelectLabel() }}
          </label>
          <select
            name="cmbTaahodat"
            id="cmbTaahodat"
            class="form-control bnp-dp-select Pointer"
            v-model="Resultcmb"
            @change="FindTaahod(Resultcmb)"
          >
            <option disabled value="-1">
              -- یکی از حساب‌های خود را انتخاب کنید --
            </option>
            <option v-for="item in ListModel" :key="item.id" :value="item.id">
              {{ item.vcodeDesNo }} {{ item.nameFamily }}
            </option>
          </select>
        </div>

        <div class="bnp-dp-layout">
          <!-- اطلاعات -->
          <div class="bnp-dp-info">
            <div class="bnp-dp-section-title">
              <i class="fas fa-file-invoice-dollar" aria-hidden="true"></i>
              {{ GetInfoTitle() }}
            </div>
            <dl class="bnp-dp-tiles">
              <div
                v-for="row in GetInfoRows()"
                :key="row.key"
                class="bnp-dp-tile"
              >
                <dt :class="{ 'bnp-dp-success': row.success }">
                  {{ row.label }}
                </dt>
                <dd
                  :id="row.id"
                  :class="{
                    'bnp-dp-danger': row.danger,
                    'bnp-dp-success': row.success,
                  }"
                >
                  {{ row.value === "" || row.value == null ? "—" : row.value }}
                </dd>
              </div>
            </dl>

            <div class="bnp-dp-payer">
              <span class="bnp-dp-payer-title">
                <i class="fas fa-user" aria-hidden="true"></i> واریز کننده
              </span>
              <span
                v-for="row in GetPayerRows()"
                :key="row.key"
                class="bnp-dp-payer-item"
              >
                <small>{{ row.label }}:</small> <b>{{ row.value || "—" }}</b>
              </span>
            </div>
          </div>

          <!-- مبلغ و پرداخت -->
          <div class="bnp-dp-action">
            <label for="MabGhest" class="bnp-dp-label">
              {{ IsTashilat ? "مبلغ قسط" : "مبلغ واریزی" }}
            </label>
            <div class="bnp-dp-amount-wrap">
              <input
                id="MabGhest"
                dir="ltr"
                type="text"
                inputmode="numeric"
                autocomplete="off"
                placeholder="0"
                class="form-control bnp-dp-amount 3ragham"
                :disabled="IsAmountLocked"
                @keypress="$ValidNumber($event, 11)"
                v-model="Mablagh"
              />
              <span class="bnp-dp-amount-unit">{{ $GetVahedPool() }}</span>
            </div>

            <p v-if="HasAmount" class="bnp-dp-words">{{ Mab2persian }}</p>
            <p v-if="IsAmountLocked" class="bnp-dp-hint">
              <i class="fas fa-lock" aria-hidden="true"></i>
              مبلغ ثابت است و قابل تغییر نیست
            </p>
            <p v-else-if="IsBelowMin" class="bnp-dp-hint bnp-dp-hint--warn">
              <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
              حداقل مبلغ قابل پرداخت ۱۰,۰۰۰ {{ $GetVahedPool() }} است
            </p>

            <div class="bnp-dp-pay">
              <payment
                @GatewayCode="Get_GatewayCode"
                @FixVarizGhestHasJarime="FixVarizGhestHasJarime"
                @FixVarizGhest="FixVarizGhest"
                :ShowCustomDeposit="
                  IsTashilat || (IsTashilat && IsShowComboHesab)
                "
              >
                <template v-slot:ContentButtonPayment>
                  <button
                    v-if="GatewayCode != 100"
                    type="button"
                    :disabled="IsBelowMin || !HasAmount"
                    class="bnp-dp-btn"
                    @click="Payment"
                  >
                    <i
                      v-if="IsBelowMin || !HasAmount"
                      class="fas fa-lock"
                      aria-hidden="true"
                    ></i>
                    واریز {{ GetMablagh }}
                  </button>

                  <div v-if="GatewayCode == 100" class="bnp-dp-account">
                    <p class="bnp-dp-note">
                      <i class="fas fa-info-circle" aria-hidden="true"></i>
                      لطفا یکی از حساب‌های خودرا جهت واریز قسط انتخاب نمایید
                    </p>
                    <label
                      v-if="ListHesbForPar != null"
                      for="cmbHesabForDeposit"
                      class="bnp-dp-label"
                    >
                      حساب مبدا
                    </label>
                    <select
                      v-if="ListHesbForPar != null"
                      v-model="HesabForDeposit"
                      name="cmbHesabForDeposit"
                      id="cmbHesabForDeposit"
                      class="form-control bnp-dp-select Pointer"
                    >
                      <option disabled value="-1">
                        -- یکی از حساب‌های خود را انتخاب کنید --
                      </option>
                      <option
                        v-for="item in ListHesbForPar"
                        :key="item.id"
                        :value="item"
                      >
                        {{ item.vcodeDesNo }} {{ item.nameFamily }}
                      </option>
                    </select>

                    <div v-if="HesabForDeposit" class="bnp-dp-balance">
                      <span>مبلغ قابل برداشت</span>
                      <b>{{
                        $Comma3ragham(Number(HesabForDeposit.ghabelBardasht))
                      }}</b>
                    </div>

                    <button
                      v-if="HesabForDeposit"
                      type="button"
                      class="bnp-dp-btn"
                      :disabled="Lodaingrenre || IsBelowMin || !HasAmount"
                      @click="Payment2"
                    >
                      واریز {{ GetMablagh }} از حساب
                      {{ HesabForDeposit.nameFamily }}
                      {{ HesabForDeposit.desNoe }}
                    </button>
                  </div>
                </template>
              </payment>
            </div>
          </div>
        </div>
      </template>
    </net-pa-card>
  </div>
</template>
<script>
import Num2persian from "num2persian";
// import Panel from '../Tools/NetPa/Panel.vue';
import Panel from "../Tools/NetPa/Panel.vue";
import Payment from "./Payment.vue";
import Loading from "../Tools/NetPa/Loading.vue";
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";

export default {
  components: {
    Panel,
    Payment,
    Loading,
    NetPaCard,
  },
  data() {
    return {
      Lodaingrenre: false,
      HesabForDeposit: null,
      MabFormulaJarime: 0,
      CheckUpMablagh: null,
      Mablagh: "",
      Email: "",
      Des: "",
      ListHesbForPar: null,
      TaahodatIdForGetRiz: null,
      VariszStatus: false,
      DataAxiosRow: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat/GetShenaseVariz",
        Token: this.$session.get("TokenNetPa"),
      },
      ShenaseVariz: "",
      ListModel: [],
      DataAxios_cmbTaahodat: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_SahebHesab: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat/TaahodatSahebHesab",
        Token: this.$session.get("TokenNetPa"),
      },
      Resultcmb: null,
      TahoodSelected: null,
      ListTaahodatRiz: null,
      sumMabRiz: 0,
      GatewayCode: null,
      FixVariz: false,
      FixVarizHesabha: false,
      CountSelectedTaahodatRiz: 0,
      CountSelectedTaahodatRizMovaghat: 0,
      ListModelSahebHesab: null,
      DataAxios_Variz: {
        ArryfildValue: {},
        Method: "Post",
        Action: "VarizGorohi/SetVarizGorohi",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_Enteghal: {
        ArryfildValue: "",
        Method: "Post",
        Action: "EnteghalVajh",
        Token: this.$session.get("TokenNetPa"),
      },
    };
  },
  computed: {
    Mab2persian() {
      var Mab = this.Mablagh.replace(/,/g, "");
      Mab = this.$b_ToPersianNumber(Mab);
      // Mab=Mab/10
      return Num2persian(Mab) + " " + this.$GetVahedPool();
    },
    GetMablagh() {
      var Mab = this.Mablagh.replace(/,/g, "");
      Mab = this.$b_ToPersianNumber(Mab);
      // Mab=Mab/10
      var formattedPrice = this.$Comma3ragham(Mab);
      return Number(Mab) > 0 ? formattedPrice + " " + this.$GetVahedPool() : "";
    },
    RawMablagh() {
      return Number(String(this.Mablagh || "").replace(/,/g, "")) || 0;
    },
    HasAmount() {
      return this.RawMablagh > 0;
    },
    IsBelowMin() {
      return this.HasAmount && this.RawMablagh < 10000;
    },
    IsAmountLocked() {
      return this.IsTashilat ? !!this.FixVariz : !!this.FixVarizHesabha;
    },
  },
  updated() {
    this.$PutCommatoInput();
  },
  mounted() {
    document.getElementById("MabGhest").focus();
    if (this.TaahodatItem) {
      // this.GetTaahodatRiz(this.TaahodatItem.id);
      if (Number(this.TaahodatItem.mablaghSharj.replaceAll(/,/g, "")) > 0) {
        this.FixVarizHesabha = true;
        this.Mablagh =
          Number(this.TaahodatItem.mablaghSharj.replaceAll(/,/g, "")) > 0
            ? this.TaahodatItem.sumGhabelPar + ""
            : this.TaahodatItem.mablaghSharj + "";
      }
      this.GetShenase(this.TaahodatItem.vCode);
    }
    if (this.IsShowComboHesab && !this.IsTashilat) {
      this.GetListTaahodat2();
    }

    if (this.IsTashilat && this.IsShowComboHesab) {
      this.GetTashilat();
    }
    if (this.IsTashilat && !this.IsShowComboHesab) {
      if (this.mabTasveyeZodtar != undefined && this.mabTasveyeZodtar > 0) {
        this.FixVariz = true;
        this.Mablagh = this.$Comma3ragham(this.mabTasveyeZodtar);
      } else {
        this.Mablagh = this.$Comma3ragham(this.TaahodatItem.sumGhabelPar);
        this.CheckUpMablagh = this.TaahodatItem.sumGhabelPar;
      }
    }
  },
  methods: {
    // ---------- Helpers for the template ----------
    GetContractWord() {
      return this.$GetIsAnbohSaz() == "false" ? "تسهیلات" : "قرارداد";
    },
    GetPageTitle() {
      return this.IsTashilat
        ? "پرداخت قسط " + this.GetContractWord()
        : "فرم واریز وجه";
    },
    GetPageSubtitle() {
      return this.IsTashilat
        ? "قسط خود را از طریق درگاه پرداخت یا از حساب‌های خود پرداخت کنید"
        : "از طریق این فرم می‌توانید به حساب‌های خود واریز انجام دهید";
    },
    GetSelectLabel() {
      return this.IsTashilat
        ? "انتخاب " + this.GetContractWord()
        : "انتخاب حساب";
    },
    GetInfoTitle() {
      return this.IsTashilat
        ? "اطلاعات " + this.GetContractWord()
        : "اطلاعات حساب";
    },
    GetInfoItem() {
      if (this.IsShowComboHesab) {
        return this.TahoodSelected || this.TaahodatItem || null;
      }
      return this.TaahodatItem || this.TahoodSelected || null;
    },
    GetInfoRows() {
      const item = this.GetInfoItem() || {};
      const money = (v) =>
        v === null || v === undefined || v === "" ? "" : this.$Comma3ragham(v);
      const word = this.GetContractWord();

      if (!this.IsTashilat) {
        return [
          { key: "vCode", label: "شماره حساب", value: item.vCode || "" },
          {
            key: "shenase",
            label: "شناسه واریز",
            value: item.shenaseVariz || "",
          },
          {
            key: "ghabel",
            label: "موجودی قابل برداشت",
            value: item.ghabelBardasht ? money(item.ghabelBardasht) : "",
            success: true,
          },
        ];
      }

      return [
        { key: "vCode", label: "شماره " + word, value: item.vCode || "" },
        {
          key: "shenase",
          label: "شناسه واریز",
          value: item.shenaseVariz || "",
        },
        {
          key: "start",
          label: "تاریخ شروع اقساط",
          value: item.tarixShoroAghsat || "",
        },
        {
          key: "vam",
          label: "مبلغ " + word,
          value: money(item.mablaghVam),
        },
        {
          key: "mande",
          label: "مانده " + word,
          value: money(item.mande),
          success: true,
        },
        {
          key: "ghest",
          label: "مبلغ قسط",
          value: money(item.mablaghGhestVam),
        },
        {
          key: "count",
          label: "تعداد اقساط",
          value:
            item.tedadGhestVam === null || item.tedadGhestVam === undefined
              ? ""
              : item.tedadGhestVam,
        },
        {
          key: "jarime",
          id: "MabJarime",
          label: "مبلغ جریمه",
          value: item.wwwJarime ? money(item.wwwJarime) : "ندارد",
          danger: true,
        },
        {
          key: "unpaid",
          id: "minTarGhestBedehkar",
          label: "سررسید قسط پرداخت نشده",
          value: item.minTarGhestBedehkar || "ندارد",
          danger: true,
        },
      ];
    },
    GetPayerRows() {
      const user = this.$session.get("UserInfoNetPa") || {};
      return [
        {
          key: "name",
          label: "مشخصات",
          value: ((user.ozvName || "") + " " + (user.ozvFamily || "")).trim(),
        },
        { key: "meli", label: "کد ملی", value: user.codeMeli || "" },
        { key: "mobile", label: "همراه", value: user.mobile || "" },
      ];
    },
    GetShenase(Vcode) {
      const formData = new FormData();
      formData.append("Vcode", Vcode);
      this.DataAxiosRow.ArryfildValue = formData;
      this.$PostFormData(this.DataAxiosRow).then((data) => {
        this.ShenaseVariz = data;

        return data;
      });
    },
    GetListTaahodat2() {
      const formData = new FormData();
      let info;
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      formData.append(
        "wwwtblSarfaslTypeId",
        this.wwwtblSarfaslTypeId == undefined ? 2 : this.wwwtblSarfaslTypeId,
      );
      this.DataAxios_cmbTaahodat.ArryfildValue = formData;
      this.$PostFormData(this.DataAxios_cmbTaahodat)
        .then((data) => {
          this.IsLoad = true;
          if (this.wwwtblSarfaslTypeId == undefined) {
            this.ListModel = data.filter(
              (x) => x.isPayment == true && x.tblSarfaslTypeId != 6,
            );
          } else {
            this.ListModel = data;
          }

          // this.Resultcmb=data[0].id
          // this.TahoodSelected=data[0]
          // انتخاب حساب پیشفرض برای واریز (درخواست یگانه سخاوت)
          if (data.filter((x) => x.pishfarz == true)[0]) {
            this.Resultcmb = data.filter((x) => x.pishfarz == true)[0].id;
            this.TahoodSelected = data.filter((x) => x.pishfarz == true)[0];
          } else {
            this.Resultcmb = data[0].id;

            this.TahoodSelected = data[0];
          }
          if (this.TahoodSelected.mablaghSharj > 0) {
            this.Mablagh =
              this.TahoodSelected.sumGhabelPar == 0
                ? this.$Comma3ragham(this.TahoodSelected.mablaghSharj)
                : this.$Comma3ragham(this.TahoodSelected.sumGhabelPar);
            this.FixVarizHesabha = true;
          } else {
            this.FixVarizHesabha = false;
          }
          // this.GetShenase(this.TahoodSelected.vCode);
        })
        .finally(() => {
          const formData = new FormData();
          formData.append(
            "wwwtblAzaId",
            this.$session.get("UserInfoNetPa").wwwtblAzaId,
          );
          formData.append(
            "wwwtblSarfaslTypeId",
            this.wwwtblSarfaslTypeId == undefined
              ? 2
              : this.wwwtblSarfaslTypeId,
          );
          this.DataAxios_SahebHesab.ArryfildValue = formData;
          this.$PostFormData(this.DataAxios_SahebHesab).then((data) => {
            if (data.length > 0) {
              this.IsLoad = true;
              this.ListModelSahebHesab = data.filter(
                (x) => x.mande >= 0 && x.isPayment == true,
              );
              for (
                let index = 0;
                index < this.ListModelSahebHesab.length;
                index++
              ) {
                // if((this.ListModelSahebHesab[index].mande-this.ListModelSahebHesab[index].sumMabTaeedNaShode)>0){
                info = this.ListModelSahebHesab[index];
                this.ListModel.push(info);
              }
              // }
            }
          });
        });
    },
    GetListTaahodatDargah() {
      const formData = new FormData();
      let info;
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      formData.append(
        "wwwtblSarfaslTypeId",
        this.wwwtblSarfaslTypeId == undefined ? 2 : this.wwwtblSarfaslTypeId,
      );
      this.DataAxios_cmbTaahodat.ArryfildValue = formData;
      this.$PostFormData(this.DataAxios_cmbTaahodat).then((data) => {
        this.IsLoad = true;
        if (this.wwwtblSarfaslTypeId == undefined) {
          this.ListHesbForPar = data.filter(
            (x) => x.isPayment == true && x.tblSarfaslTypeId != 6,
          );
        } else {
          this.ListHesbForPar = data;
        }

        // this.GetShenase(this.TahoodSelected.vCode);
      });
    },
    FindTaahod(taahodId) {
      if (taahodId != -1) {
        this.ListModel.forEach((element) => {
          if (element.id == taahodId) {
            // this.GetTaahodatRiz(element.id);
            this.TahoodSelected = element;
            this.GetShenase(this.TahoodSelected.vCode);
            this.Mablagh = this.$Comma3ragham(element.sumGhabelPar);
            if (
              element.sumGhabelPar > 0 &&
              element.sumGhabelPar != null &&
              this.FixVariz == true
            ) {
              document.getElementById("MabGhest").disabled = true;
            }

            this.CheckUpMablagh = element.sumGhabelPar;
          }
        });
      }
    },
    Payment() {
      if (!this.$OnceGuard("Payment", 5000)) return; // NetPa HANDOFF S14 : double-submit (do darxast-e dargah)
      // console.log(this.IsTashilat);
      if (this.GatewayCode == 0) {
        if (this.$session.get("CustCode") == 801) {
          this.$swal(
            "اختلال در پرداخت با درگاه",
            "مشتری گرامی به علت  اختلال موقت درگاه ، لطفا به یکی از دو روش  پرداخت نمایید با تشکر . 1- کارت به کارت از طریق عابربانک ملی به همراه شناسه پرداخت یا شناسه واریز .  (کارت بانک ملی به شماره : 6037.9911.9952.6827)  2-  واریز به حساب از سامانه بام به همراه شناسه واریز یا شناسه پرداخت . (شماره حساب بانک ملی : 0110008020006)",
            "warning",
          );
        } else {
          this.$mySweetDefaultTost(
            "عدم انتخاب درگاه",
            "درگاهی برای سامانه تنظیم نشده است",
            "warning",
            3000,
          );
        }
      } else {
        try {
          if (this.$session.get("CustCode") == 868) {
            if (this.IsTashilat != true) {
              if (Number(this.Mablagh.replaceAll(/,/g, "")) % 10000 === 0) {
                //console.log('😎 ~ Payment ~ this.Mablagh:', this.Mablagh)
                //چهار رقم آخر صفر می باشد
                if (this.IsTashilat && !this.IsShowComboHesab) {
                  if (
                    Number(this.Mablagh.replaceAll(/,/g, "")) >
                    Number(this.TaahodatItem.mande.replaceAll(/,/g, "")) +
                      Number(this.TaahodatItem.wwwJarime) -
                      Number(
                        this.TaahodatItem.sumMabTaeedNaShode.replaceAll(
                          /,/g,
                          "",
                        ),
                      )
                  ) {
                    //console.log('😎 ~ Payment ~ this.Mablagh:', this.Mablagh)
                    this.$mySweetDefault(
                      "عدم پرداخت",
                      "مبلغ پرداختی بیشتر از مانده تسهیلات شما می باشد .",
                      "error",
                      3000,
                    );
                  } else {
                    this.FormulaJarime();
                  }
                }
                if (this.IsTashilat && this.IsShowComboHesab) {
                  if (
                    Number(this.Mablagh.replaceAll(/,/g, "")) >
                    this.TahoodSelected.mande +
                      this.TahoodSelected.wwwJarime -
                      this.TahoodSelected.sumMabTaeedNaShode
                  ) {
                    //console.log('😎 ~ Payment ~ this.Mablagh:', this.Mablagh)
                    this.$mySweetDefault(
                      "عدم پرداخت",
                      "مبلغ پرداختی بیشتر از مانده تسهیلات شما می باشد .",
                      "error",
                      3000,
                    );
                  } else {
                    this.FormulaJarime();
                  }
                }
                if (!this.IsTashilat) {
                  this.SetPayment();
                }
              } else {
                //چهار رقم آخر صفر نیست
                this.$mySweetDefaultTost(
                  "خطا در مبلغ واریزی",
                  "سرمایه طبق دستور بانک مرکزی باید به صورت رند (چهار رقم آخر مبلغ صفر باشد) وارد شود لطفا مبلغ واریزی را بررسی کنید",
                  "warning",
                  7000,
                );
              }
            }
            if (this.IsTashilat == true) {
              if (this.IsTashilat && !this.IsShowComboHesab) {
                if (
                  Number(this.Mablagh.replaceAll(/,/g, "")) >
                  Number(this.TaahodatItem.mande.replaceAll(/,/g, "")) +
                    Number(this.TaahodatItem.wwwJarime) -
                    Number(
                      this.TaahodatItem.sumMabTaeedNaShode.replaceAll(/,/g, ""),
                    )
                ) {
                  //console.log('😎 ~ Payment ~ this.Mablagh:', this.Mablagh)
                  this.$mySweetDefault(
                    "عدم پرداخت",
                    "مبلغ پرداختی بیشتر از مانده تسهیلات شما می باشد .",
                    "error",
                    3000,
                  );
                } else {
                  this.FormulaJarime();
                }
              }
              if (this.IsTashilat && this.IsShowComboHesab) {
                if (
                  Number(this.Mablagh.replaceAll(/,/g, "")) >
                  this.TahoodSelected.mande +
                    this.TahoodSelected.wwwJarime -
                    this.TahoodSelected.sumMabTaeedNaShode
                ) {
                  //console.log('😎 ~ Payment ~ this.Mablagh:', this.Mablagh)
                  this.$mySweetDefault(
                    "عدم پرداخت",
                    "مبلغ پرداختی بیشتر از مانده تسهیلات شما می باشد .",
                    "error",
                    3000,
                  );
                } else {
                  this.FormulaJarime();
                }
              }
              if (!this.IsTashilat) {
                this.SetPayment();
              }
            }
          } else {
            if (this.IsTashilat && !this.IsShowComboHesab) {
              if (
                Number(this.Mablagh.replaceAll(/,/g, "")) >
                Number(this.TaahodatItem.mande.replaceAll(/,/g, "")) +
                  Number(this.TaahodatItem.wwwJarime) -
                  Number(
                    this.TaahodatItem.sumMabTaeedNaShode.replaceAll(/,/g, ""),
                  )
              ) {
                //console.log('😎 ~ Payment ~ this.Mablagh:', this.Mablagh)
                this.$mySweetDefault(
                  "عدم پرداخت",
                  "مبلغ پرداختی بیشتر از مانده تسهیلات شما می باشد .",
                  "error",
                  3000,
                );
              } else {
                this.FormulaJarime();
              }
            }
            if (this.IsTashilat && this.IsShowComboHesab) {
              if (
                Number(this.Mablagh.replaceAll(/,/g, "")) >
                this.TahoodSelected.mande +
                  this.TahoodSelected.wwwJarime -
                  this.TahoodSelected.sumMabTaeedNaShode
              ) {
                //console.log('😎 ~ Payment ~ this.Mablagh:', this.Mablagh)
                this.$mySweetDefault(
                  "عدم پرداخت",
                  "مبلغ پرداختی بیشتر از مانده تسهیلات شما می باشد .",
                  "error",
                  3000,
                );
              } else {
                this.FormulaJarime();
              }
            }
            if (this.IsTashilat == false) {
              this.SetPayment();
            }
          }
          //--------------------------------------------------------------------------------------------
          this.$store.state.loadingRender = true;
          this.$store.state.loadingRender = false;
        } catch (error) {
          //--------------------------------------------------------------------------------------------
          this.$store.state.loadingRender = true;
          this.$store.state.loadingRender = false;
        }
      }
    },
    Payment2() {
      if (this.IsTashilat && !this.IsShowComboHesab) {
        if (
          Number(this.Mablagh.replaceAll(/,/g, "")) >
          Number(this.TaahodatItem.mande.replaceAll(/,/g, "")) +
            Number(this.TaahodatItem.wwwJarime) -
            Number(this.TaahodatItem.sumMabTaeedNaShode.replaceAll(/,/g, ""))
        ) {
          //console.log('😎 ~ Payment2 ~ this.Mablagh:', this.Mablagh)
          this.$mySweetDefault(
            "عدم پرداخت",
            "مبلغ پرداختی بیشتر از مانده تسهیلات شما می باشد .",
            "error",
            3000,
          );
        } else {
          this.FormulaJarime2();
        }
      }
      if (this.IsTashilat && this.IsShowComboHesab) {
        if (
          Number(this.Mablagh.replaceAll(/,/g, "")) >
          this.TahoodSelected.mande +
            this.TahoodSelected.wwwJarime -
            this.TahoodSelected.sumMabTaeedNaShode
        ) {
          //console.log('😎 ~ Payment2 ~ this.Mablagh:', this.Mablagh)
          this.$mySweetDefault(
            "عدم پرداخت",
            "مبلغ پرداختی بیشتر از مانده تسهیلات شما می باشد .",
            "error",
            3000,
          );
        } else {
          this.FormulaJarime2();
        }
      }
    },
    FormulaJarime() {
      if (
        Number(this.Mablagh.replaceAll(/,/g, "")) < Number(this.CheckUpMablagh)
      ) {
        //console.log('😎 ~ FormulaJarime ~ this.Mablagh:', this.Mablagh)
        var MablaghJarime = this.TaahodatItem
          ? this.TaahodatItem.wwwJarime
          : this.TahoodSelected.wwwJarime;
        if (this.$session.get("CustCode") == 561) {
          this.MabFormulaJarime =
            (Number(this.Mablagh.replaceAll(/,/g, "")) /
              Number(this.CheckUpMablagh)) *
            MablaghJarime;
        } else {
          this.MabFormulaJarime =
            (Number(this.Mablagh.replaceAll(/,/g, "")) /
              (Number(this.CheckUpMablagh) - MablaghJarime)) *
            MablaghJarime;
        }
        this.SetPayment();
      } else {
        this.MabFormulaJarime = this.TaahodatItem
          ? this.TaahodatItem.wwwJarime
          : this.TahoodSelected.wwwJarime;
        this.SetPayment();
      }
    },
    FormulaJarime2() {
      if (
        Number(this.Mablagh.replaceAll(/,/g, "")) < Number(this.CheckUpMablagh)
      ) {
        var MablaghJarime = this.TaahodatItem
          ? this.TaahodatItem.wwwJarime
          : this.TahoodSelected.wwwJarime;
        if (this.$session.get("CustCode") == 561) {
          this.MabFormulaJarime =
            (Number(this.Mablagh.replaceAll(/,/g, "")) /
              Number(this.CheckUpMablagh)) *
            MablaghJarime;
        } else {
          this.MabFormulaJarime =
            (Number(this.Mablagh.replaceAll(/,/g, "")) /
              (Number(this.CheckUpMablagh) - MablaghJarime)) *
            MablaghJarime;
        }
        this.SetPayment2();
      } else {
        this.MabFormulaJarime = this.TaahodatItem
          ? this.TaahodatItem.wwwJarime
          : this.TahoodSelected.wwwJarime;
        this.SetPayment2();
      }
    },
    GetTashilat() {
      const formData = new FormData();
      let info;
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      formData.append("wwwtblSarfaslTypeId", 1);
      this.DataAxios_cmbTaahodat.ArryfildValue = formData;
      this.$PostFormData(this.DataAxios_cmbTaahodat)
        .then((data) => {
          this.IsLoad = true;
          this.ListModel = [];
          data.forEach((element) => {
            if (
              element.mande + element.wwwJarime - element.sumMabTaeedNaShode >
              0
            ) {
              this.ListModel.push(element);
              // console.error(data);
            }
          });
          this.Resultcmb = this.ListModel[0].id;
          // this.GetTaahodatRiz(this.ListModel[0].id);
          this.TahoodSelected = this.ListModel[0];
          // console.log("@@@@",this.TahoodSelected);
          this.GetShenase(this.TahoodSelected.vCode);

          this.Mablagh = this.$Comma3ragham(this.ListModel[0].sumGhabelPar);
          this.CheckUpMablagh = this.ListModel[0].sumGhabelPar;
        })
        .finally(() => {
          const formData = new FormData();
          formData.append(
            "wwwtblAzaId",
            this.$session.get("UserInfoNetPa").wwwtblAzaId,
          );
          formData.append("wwwtblSarfaslTypeId", 1);
          this.DataAxios_SahebHesab.ArryfildValue = formData;
          this.$PostFormData(this.DataAxios_SahebHesab).then((data) => {
            if (data.length > 0) {
              this.IsLoad = true;
              this.ListModelSahebHesab = data;
              for (
                let index = 0;
                index < this.ListModelSahebHesab.length;
                index++
              ) {
                if (
                  this.ListModelSahebHesab[index].mande -
                    this.ListModelSahebHesab[index].sumMabTaeedNaShode >
                  0
                ) {
                  info = this.ListModelSahebHesab[index];
                  this.ListModel.push(info);
                }
              }
            }
          });
        });
    },
    SetMablagh() {
      this.CountSelectedTaahodatRiz = this.CountSelectedTaahodatRizMovaghat;
      if (
        this.$session.get("UserInfoNetPa").cId == "801" ||
        this.$session.get("UserInfoNetPa").cId == "7777"
      ) {
        if (this.CountSelectedTaahodatRiz <= 1) {
          this.Mablagh = this.sumMabRiz + this.TahoodSelected.wwwJarime + "";
        } else {
          document.getElementById("MabJarime").textContent = "ندارد";
          this.Mablagh = this.sumMabRiz + "";
        }
      } else {
        this.Mablagh = this.sumMabRiz + this.TahoodSelected.wwwJarime + "";
      }
    },
    Get_GatewayCode(val) {
      this.GatewayCode = val;
      if (this.GatewayCode == 100) {
        // this.GetListTaahodat2()
        this.GetListTaahodatDargah();
      }
    },
    FixVarizGhest(val) {
      // if (this.mabTasveyeZodtar == 0 || this.mabTasveyeZodtar == undefined)
      this.FixVariz = val;
    },
    FixVarizGhestHasJarime(val) {
      var jarime =
        this.TaahodatItem && this.TaahodatItem.wwwJarime != null
          ? this.TaahodatItem.wwwJarime
          : this.TahoodSelected.wwwJarime;
      if (jarime > 0) {
        this.FixVariz = val;
      }
    },
    SumMablagh(val) {
      var jarime = this.TaahodatItem
        ? this.TaahodatItem.wwwJarime
        : this.TahoodSelected.wwwJarime;
      this.Mablagh = val + jarime + "";
    },
    SetPayment() {
      // console.log(this.TaahodatItem);
      // console.log(this.TahoodSelected);
      var SharhRiz = "";
      if (this.mabTasveyeZodtar > 0 && this.mabReturnrKarmozd > 0)
        SharhRiz = this.TaahodatItem.vCode + " تسویه زود تر از موعد ";
      else
        SharhRiz =
          (this.TaahodatItem
            ? this.TaahodatItem.vCode
            : this.TahoodSelected.vCode) + "پرداخت/ واریز  تکی";
      const WwwtblVarizGorohiRiz = [];
      WwwtblVarizGorohiRiz.push({
        WwwtblTaahodatId: this.TaahodatItem
          ? this.TaahodatItem.id
          : this.TahoodSelected.id,
        Mablagh: Number(this.Mablagh.replaceAll(/,/g, "")),
        SharhRiz: SharhRiz,
        WwwtblAzaId: this.TaahodatItem
          ? this.TaahodatItem.wwwtblAzaId
          : this.TahoodSelected.wwwtblAzaId,
        BnpCashDBtblTaahodatId: this.TaahodatItem
          ? this.TaahodatItem.bnpCashDBtblTaahodatId
          : this.TahoodSelected.bnpCashDBtblTaahodatId,
        BnpCashDBtblAzaId: this.TaahodatItem
          ? this.TaahodatItem.bnpCashDBtblAzaId
          : this.TahoodSelected.bnpCashDBtblAzaId,
        MablaghJarime: Math.floor(this.MabFormulaJarime), //this.TaahodatItem ? this.TaahodatItem.wwwJarime : this.TahoodSelected.wwwJarime,
        TarixGhest: this.TaahodatItem
          ? this.TaahodatItem.minTarGhestBedehkar.replaceAll(/,/g, "")
          : this.TahoodSelected.minTarGhestBedehkar.replaceAll(/,/g, ""),
        IsTaahodatRiz: false,
        MabReturnrKarmozd:
          this.mabReturnrKarmozd > 0 ? this.mabReturnrKarmozd : 0,
      });
      (this.DataAxios_Variz.ArryfildValue.Mablagh = Number(
        this.Mablagh.replaceAll(/,/g, ""),
      )),
        (this.DataAxios_Variz.ArryfildValue.CodeRahgiri = 0);
      this.DataAxios_Variz.ArryfildValue.Tarix = this.$store.state.JalaliDate;
      this.DataAxios_Variz.ArryfildValue.Sharh =
        this.mabTasveyeZodtar > 0 && this.mabReturnrKarmozd > 0
          ? " تسویه زود تر از موعد "
          : "پرداخت/ واریز  تکی";
      this.DataAxios_Variz.ArryfildValue.ZamanInsert =
        this.$store.state.JalaliDate;
      this.DataAxios_Variz.ArryfildValue.CustCode = Number(
        this.$session.get("UserInfoNetPa").custCode,
      );
      this.DataAxios_Variz.ArryfildValue.tblComboIdVaziatGrp312 = 5538;
      this.DataAxios_Variz.ArryfildValue.wwwtblAzaId =
        this.$session.get("UserInfoNetPa").wwwtblAzaId;
      this.DataAxios_Variz.ArryfildValue.StatusVariz = 2;
      this.DataAxios_Variz.ArryfildValue.WwwtblVarizGorohiRiz =
        WwwtblVarizGorohiRiz;
      this.$PostData(this.DataAxios_Variz).then((result) => {
        if (result.status === "Success") {
          this.$Payment(
            this.GatewayCode + "",
            this.Mablagh,
            this.$session.get("UserInfoNetPa").ozvName +
              " " +
              this.$session.get("UserInfoNetPa").ozvFamily,
            this.$session.get("UserInfoNetPa").email,
            this.$session.get("UserInfoNetPa").mobile,
            WwwtblVarizGorohiRiz[0].WwwtblTaahodatId,
            this.TaahodatItem
              ? this.TaahodatItem.shenaseVariz
              : this.TahoodSelected.shenaseVariz,
            this.TaahodatItem
              ? this.TaahodatItem.vCode
              : this.TahoodSelected.vCode,
            "پرداخت/واریز تکی",
            JSON.stringify(this.$session.get("UserInfoNetPa").wwwtblAzaId),
            this.$session.get("UserInfoNetPa").custCode,
            JSON.stringify(this.$session.get("UserInfoNetPa").wwwtblShobeId),
            result.idRepoMaster,
            this.$session.get("UserInfoNetPa").codeMeli,
            this.TaahodatItem
              ? this.TaahodatItem.nameFamily
              : this.TahoodSelected.nameFamily,
            this.TaahodatItem
              ? this.TaahodatItem.mobile
              : this.TahoodSelected.mobile,
            this.TaahodatItem
              ? this.TaahodatItem.codeMeli.trim()
              : this.TahoodSelected.codeMeli.trim(),
          );
        } else {
          this.$mySweetDefaultTost(
            " ",
            " در پرداخت مشکلی پیش آمده لطفا مجددا تلاش فرمایید",
            "warning",
            2000,
          );
          this.DeleteAllItemsCart();
        }
      });
    },
    SetPayment2() {
      var SharhRiz = "";
      if (this.mabTasveyeZodtar > 0 && this.mabReturnrKarmozd > 0)
        SharhRiz = this.TaahodatItem.vCode + " تسویه زود تر از موعد از حساب";
      else
        SharhRiz =
          (this.TaahodatItem
            ? this.TaahodatItem.vCode
            : this.TahoodSelected.vCode) + " پرداخت/ واریز  تکی از حساب";

      // console.log(Number(this.HesabForDeposit.ghabelBardasht) + Number(this.HesabForDeposit.sumMabTaeedNaShode))
      // console.log(Number(this.Mablagh.replaceAll(/,/g, '')))
      if (
        Number(this.HesabForDeposit.ghabelBardasht) <
        Number(this.Mablagh.replaceAll(/,/g, ""))
      ) {
        this.$mySweetDefaultTost(
          "عدم موجودی",
          "موجودی حساب شما کمتراز مبلغ اقساط شما می باشد ",
          "error",
          3000,
        );
        return;
      } else {
        this.Lodaingrenre = true;
        const WwwtblVarizGorohiRiz = [];
        /*wwwtblTaahodatIdBestanKar*/
        WwwtblVarizGorohiRiz.push({
          WwwtblTaahodatId: this.TaahodatItem
            ? this.TaahodatItem.id
            : this.TahoodSelected.id,
          Mablagh: Number(this.Mablagh.replaceAll(/,/g, "")),
          SharhRiz: SharhRiz,
          WwwtblAzaId: this.TaahodatItem
            ? this.TaahodatItem.wwwtblAzaId
            : this.TahoodSelected.wwwtblAzaId,
          BnpCashDBtblTaahodatId: this.TaahodatItem
            ? this.TaahodatItem.bnpCashDBtblTaahodatId
            : this.TahoodSelected.bnpCashDBtblTaahodatId,
          BnpCashDBtblAzaId: this.TaahodatItem
            ? this.TaahodatItem.bnpCashDBtblAzaId
            : this.TahoodSelected.bnpCashDBtblAzaId,
          MablaghJarime: Math.floor(this.MabFormulaJarime), //this.TaahodatItem ? this.TaahodatItem.wwwJarime : this.TahoodSelected.wwwJarime,
          TarixGhest: this.TaahodatItem
            ? this.TaahodatItem.minTarGhestBedehkar.replaceAll(/,/g, "")
            : this.TahoodSelected.minTarGhestBedehkar.replaceAll(/,/g, ""),
          IsTaahodatRiz: false,
          MabReturnrKarmozd:
            this.mabReturnrKarmozd > 0 ? this.mabReturnrKarmozd : 0,
        });

        /*wwwtblTaahodatIdBestanKar*/

        this.DataAxios_Variz.ArryfildValue.Mablagh = Number(
          this.Mablagh.replaceAll(/,/g, ""),
        );
        this.DataAxios_Variz.ArryfildValue.CodeRahgiri = 0;
        this.DataAxios_Variz.ArryfildValue.Tarix = this.$GetJalaliDate();
        this.DataAxios_Variz.ArryfildValue.Sharh = SharhRiz;
        this.DataAxios_Variz.ArryfildValue.ZamanInsert =
          this.$GetJalaliDateTime();
        this.DataAxios_Variz.ArryfildValue.CustCode = Number(
          this.$session.get("UserInfoNetPa").custCode,
        );
        this.DataAxios_Variz.ArryfildValue.tblComboIdVaziatGrp312 = 5538;
        this.DataAxios_Variz.ArryfildValue.wwwtblAzaId =
          this.$session.get("UserInfoNetPa").wwwtblAzaId;
        this.DataAxios_Variz.ArryfildValue.StatusVariz = 2;
        this.DataAxios_Variz.ArryfildValue.WwwtblVarizGorohiRiz =
          WwwtblVarizGorohiRiz;

        this.$PostData(this.DataAxios_Variz).then((result) => {
          if (result.status === "Success") {
            //console.log('😎 ~ this.$PostData ~ result:', result)

            ////کدهای ثبت انتقال وجه
            const formData = new FormData();
            formData.append(
              "wwwtblAzaId",
              this.$session.get("UserInfoNetPa").wwwtblAzaId,
            );
            if (this.Result != null) {
              formData.append(
                "wwwtblTaahodatIdBestanKar",
                this.TaahodatItem
                  ? this.TaahodatItem.id
                  : this.TahoodSelected.id,
              );
            } else {
              formData.append(
                "wwwtblTaahodatIdBestanKar",
                this.TaahodatItem
                  ? this.TaahodatItem.id
                  : this.TahoodSelected.id,
              );
            }
            formData.append(
              "wwwtblTaahodatIdBedehKar",
              this.HesabForDeposit.id,
            );
            formData.append(
              "Mablagh",
              Number(this.Mablagh.replaceAll(/,/g, "")),
            );
            formData.append("Desc", SharhRiz);
            formData.append("KodRahgiri", "");
            formData.append("CardNo", "");
            formData.append("ShebaNo", "");
            formData.append(
              "NameSahebHesab",
              this.$session.get("UserInfoNetPa").ozvName +
                " " +
                this.$session.get("UserInfoNetPa").ozvFamily,
            );
            formData.append("EnteghalNoe", 2);
            formData.append("HesabNo", "");
            formData.append("OrderId", "-2");
            formData.append("MabKarmozdEnteghal", 0);
            formData.append("MabKarmozdBnp", 0);
            formData.append("BankName", "");
            formData.append("ComboIdGrp324", 0);
            formData.append("TarixSanad", this.$GetJalaliDate());
            formData.append("VarizGorohiId", result.idRepoMaster);
            formData.append("wwwJarime", this.MabFormulaJarime);
            this.DataAxios_Enteghal.ArryfildValue = formData;
            if (!this.$OnceGuard("EnteghalVajh", 8000)) return; // NetPa HANDOFF S14 : double-submit
            this.$PostFormData(this.DataAxios_Enteghal)
              .then((data) => {
                if (data.id > 0 && data.success == "SUCCESS") {
                  this.$mySweetDefaultTost(
                    "انتقال موفق",
                    "انتقال وجه با موفقیت انجام شد کد رهگیری : " +
                      data.codeRahgiri,
                    "success",
                    6000,
                  );
                } else {
                  this.$mySweetDefaultTost(
                    "مشکل در انتقال وجه",
                    "مشکلی در انتقال وجه پیش آمده لطفا مجددا تلاش کنید",
                    "warning",
                    3000,
                  );
                }
              })
              .finally(() => {
                this.Lodaingrenre = false;
              });

            ////کدهای ثبت انتقال وجه
          }
        });
      }
    },
  },
  created() {
    if (this.wwwtblAzaId) {
      this.$session.set("UserFromLoan", [this.wwwtblAzaId, false]);
    }
    if (this.wwwtblAzaIdAccount) {
      this.$session.set("UserFromAccount", [this.wwwtblAzaIdAccount, false]);
    }
  },
  props: [
    "IsShowComboHesab",
    "TaahodatItem",
    "IsTashilat",
    "wwwtblAzaId",
    "wwwtblAzaIdAccount",
    "mabTasveyeZodtar",
    "mabReturnrKarmozd",
  ],
};
</script>
<style scoped>
.bnp-dp {
  --bnp-brand-navy: #29345f;
  --bnp-brand-indigo: #56508d;
  --bnp-brand-purple: #8d58a4;
  --bnp-brand-cyan: #05b8c8;
  --bnp-brand-blue: #287db4;
  --bnp-text-primary: #13243a;
  --bnp-text-secondary: #6b7b8e;
  --bnp-surface-subtle: #f9fbfc;
  --bnp-surface-accent: #edf7fb;
  --bnp-info-soft: #edf5fb;
  --bnp-border-default: #dbe5eb;
  --bnp-border-subtle: #e8eef2;
  --bnp-border-hover: #bdcbd4;
  --bnp-warning: #c48726;
  --bnp-warning-soft: #fff7e8;
  --bnp-danger: #b44f46;
  --bnp-radius-md: 14px;
  --bnp-shadow-md: 0 12px 24px rgba(41, 52, 95, 0.18);
  --bnp-focus-color: #05b8c8;
  --bnp-focus-ring: 0 0 0 4px rgba(5, 184, 200, 0.2);
  --bnp-motion-fast: 180ms;

  max-width: 1060px;
  padding-top: 4px;
  padding-bottom: 16px;
  color: var(--bnp-text-primary);
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  text-align: right;
}

/* ---------- Layout: دو ستون داخل یک کارت ---------- */
.bnp-dp-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(0, 1fr);
  gap: 24px;
  align-items: start;
}

.bnp-dp-info {
  min-width: 0;
}

.bnp-dp-action {
  min-width: 0;
  padding-right: 24px;
  border-right: 1px solid var(--bnp-border-subtle);
}

.bnp-dp-section-title {
  margin-bottom: 10px;
  color: var(--bnp-brand-navy);
  font-size: 13px;
  font-weight: 800;
}

.bnp-dp-section-title i {
  margin-left: 6px;
  color: var(--bnp-brand-blue);
}

/* ---------- Label / Select ---------- */
.bnp-dp-label {
  display: block;
  margin-bottom: 6px;
  color: var(--bnp-text-primary);
  font-size: 13px;
  font-weight: 700;
}

.bnp-dp-select-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--bnp-border-subtle);
}

.bnp-dp-select-row .bnp-dp-label {
  flex: 0 0 auto;
  margin-bottom: 0;
}

.bnp-dp-select {
  height: 48px;
  padding: 0 16px;
  color: var(--bnp-text-primary);
  font-family: inherit;
  font-size: 14px !important;
  border: 1px solid var(--bnp-border-default);
  border-radius: var(--bnp-radius-md);
  background-color: var(--bnp-surface-subtle);
  transition:
    border-color var(--bnp-motion-fast) ease,
    box-shadow var(--bnp-motion-fast) ease;
}

.bnp-dp-select:hover {
  border-color: var(--bnp-border-hover);
}

.bnp-dp-select:focus {
  border-color: var(--bnp-focus-color);
  background-color: #fff;
  box-shadow: var(--bnp-focus-ring);
  outline: none;
}

/* ---------- Info tiles ---------- */
.bnp-dp-tiles {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin: 0;
}

.bnp-dp-tile {
  min-width: 0;
  padding: 10px 12px;
  border: 1px solid var(--bnp-border-subtle);
  border-radius: 12px;
  background: var(--bnp-surface-subtle);
}

.bnp-dp-tile dt {
  margin: 0 0 2px;
  color: var(--bnp-text-secondary);
  font-size: 12px;
  font-weight: 400;
  line-height: 1.8;
}

.bnp-dp-tile dd {
  margin: 0;
  color: var(--bnp-text-primary);
  font-size: 14px;
  font-weight: 700;
  line-height: 1.6;
  word-break: break-word;
}

.bnp-dp-tile dd.bnp-dp-danger {
  color: var(--bnp-danger);
}

.bnp-dp-tile dt.bnp-dp-success,
.bnp-dp-tile dd.bnp-dp-success {
  color: #28a745;
}

/* ---------- Payer strip ---------- */
.bnp-dp-payer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 16px;
  margin-top: 12px;
  padding: 10px 14px;
  font-size: 13px;
  border-radius: 12px;
  background: var(--bnp-info-soft);
}

.bnp-dp-payer-title {
  color: var(--bnp-brand-navy);
  font-weight: 800;
}

.bnp-dp-payer-title i {
  margin-left: 6px;
  color: var(--bnp-brand-blue);
}

.bnp-dp-payer-item small {
  color: var(--bnp-text-secondary);
  font-size: 12px;
}

.bnp-dp-payer-item b {
  font-weight: 700;
}

/* ---------- Amount ---------- */
.bnp-dp-amount-wrap {
  position: relative;
}

.bnp-dp-amount {
  height: 56px;
  padding: 0 64px;
  color: var(--bnp-brand-navy);
  font-family: inherit;
  font-size: 22px !important;
  font-weight: 800;
  text-align: center;
  border: 1px solid var(--bnp-border-default);
  border-radius: var(--bnp-radius-md);
  background: var(--bnp-surface-subtle);
  transition:
    border-color var(--bnp-motion-fast) ease,
    box-shadow var(--bnp-motion-fast) ease;
}

.bnp-dp-amount:hover {
  border-color: var(--bnp-border-hover);
}

.bnp-dp-amount:focus {
  border-color: var(--bnp-focus-color);
  background: #fff;
  box-shadow: var(--bnp-focus-ring);
  outline: none;
}

.bnp-dp-amount:disabled {
  opacity: 0.65;
  cursor: not-allowed;
  background: var(--bnp-surface-accent);
}

.bnp-dp-amount-unit {
  position: absolute;
  top: 50%;
  left: 16px;
  transform: translateY(-50%);
  color: var(--bnp-text-secondary);
  font-size: 12px;
  font-weight: 700;
  pointer-events: none;
}

.bnp-dp-words {
  margin: 8px 0 0;
  color: var(--bnp-brand-navy);
  font-size: 12px;
  line-height: 1.8;
  text-align: center;
}

.bnp-dp-hint {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 8px 0 0;
  color: var(--bnp-text-secondary);
  font-size: 12px;
  line-height: 1.8;
}

.bnp-dp-hint--warn {
  padding: 6px 12px;
  color: #8a5d12;
  border-radius: 10px;
  background: var(--bnp-warning-soft);
}

.bnp-dp-hint--warn i {
  color: var(--bnp-warning);
}

/* ---------- Payment ---------- */
.bnp-dp-pay {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid var(--bnp-border-subtle);
}

.bnp-dp-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 52px;
  margin-top: 4px;
  padding: 10px 22px;
  color: #fff;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.6;
  border: 0;
  border-radius: var(--bnp-radius-md);
  outline: none;
  cursor: pointer;
  background: linear-gradient(
    110deg,
    var(--bnp-brand-navy),
    var(--bnp-brand-indigo) 58%,
    var(--bnp-brand-purple)
  );
  box-shadow: var(--bnp-shadow-md);
  transition:
    transform var(--bnp-motion-fast) ease,
    box-shadow var(--bnp-motion-fast) ease;
}

.bnp-dp-btn:hover:not(:disabled) {
  transform: translateY(-2px);
}

.bnp-dp-btn:focus-visible {
  box-shadow: var(--bnp-focus-ring);
}

.bnp-dp-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
}

.bnp-dp-account {
  margin-top: 4px;
}

.bnp-dp-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0 0 10px;
  padding: 8px 12px;
  color: var(--bnp-text-primary);
  font-size: 12px;
  line-height: 1.8;
  border-radius: 12px;
  background: var(--bnp-info-soft);
}

.bnp-dp-note i {
  margin-top: 5px;
  color: var(--bnp-brand-blue);
}

.bnp-dp-balance {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 10px 0 2px;
  padding: 8px 14px;
  color: #047a6c;
  font-size: 13px;
  border-radius: 12px;
  background: rgba(5, 168, 149, 0.1);
}

.bnp-dp-balance b {
  color: var(--bnp-text-primary);
  font-size: 15px;
}

/* هماهنگ‌سازی ظاهر کامپوننت درگاه با پالت NetPa */
.bnp-dp-pay >>> .border-warning {
  border-color: var(--bnp-border-subtle) !important;
}

.bnp-dp-pay >>> .text-dark {
  color: var(--bnp-text-primary) !important;
}

.bnp-dp-pay >>> .SelectedImageIcon {
  outline: 2px solid var(--bnp-focus-color);
  outline-offset: 2px;
  box-shadow: var(--bnp-focus-ring);
}

/* ---------- Responsive ---------- */
@media (max-width: 991px) {
  .bnp-dp-layout {
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
  }

  .bnp-dp-action {
    padding-right: 0;
    padding-top: 16px;
    border-right: 0;
    border-top: 1px solid var(--bnp-border-subtle);
  }

  .bnp-dp-tiles {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 575px) {
  .bnp-dp {
    padding-right: 8px;
    padding-left: 8px;
  }

  .bnp-dp-select-row {
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
  }

  .bnp-dp-amount {
    height: 52px;
    font-size: 20px !important;
  }
}

@media (prefers-reduced-motion: reduce) {
  .bnp-dp-select,
  .bnp-dp-amount,
  .bnp-dp-btn {
    transition: none;
  }

  .bnp-dp-btn:hover:not(:disabled) {
    transform: none;
  }
}
</style>
